// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-margin {
  margin-left: -5px !important;
  margin-right: -5px !important;
}

.margin {
  margin-top: 0px !important;
}

.download-list-content:last-child {
  border-bottom: none !important;
}

.disabled-list {
  pointer-events: none !important;
  opacity: 0.4 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/right-menu/trip-information/trip-info/trip-info.component.scss"],"names":[],"mappings":"AAAA;EACE,4BAAA;EACA,6BAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,+BAAA;EACA,uBAAA;AACF","sourcesContent":[".card-margin {\n  margin-left: -5px !important;\n  margin-right: -5px !important;\n}\n\n.margin {\n  margin-top: 0px !important;\n}\n\n.download-list-content:last-child {\n  border-bottom: none !important;\n}\n\n.disabled-list {\n  pointer-events: none !important; //This makes it not clickable\n  opacity: 0.4 !important; //This grays it out to look disabled\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
